import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  description:
    'Retrieve table orders and allows guests to pay, split bills, and tip directly from their table, freeing up your POS register for new orders.',
  label: 'Configure Venues',
})
